// extracted by mini-css-extract-plugin
module.exports = {"container":"KioskFoodFooter_container__3Q_b8","go-back":"KioskFoodFooter_go-back__IwpKX","go-back-ltr":"KioskFoodFooter_go-back-ltr__1HneD","add":"KioskFoodFooter_add__1Hd9Y"};